import React, {Component} from 'react';
import './CommunitySidePane.css';
import {Link} from 'react-router-dom';
import {getSessionUserMembership, canAdmin, getAdmins} from './community.selectors';
import {SocialList, PrimaryButton} from '../widgets';
import {connect} from 'react-redux';
import {uiActions} from '../chrome';
import CommunityAdminList from './CommunityAdminList';
import FancyButton from '../widgets/FancyButton';
import confirmActions from '../widgets/confirmation.actions';
import communityActions from './community.actions';
import ProviderSearchDropdown from '../search/ProviderSearchDropdown';
import userHasBaseDetails from '../user/userHasBaseDetails';
import {B2ME_COMM_UUID} from './index';

export class CommunitySidePane extends Component {
	render() {
		const {
			community: {
				uuid,
				name,
				contacts,
				profile: {about, uniqueName},
				noticesAllowAll
			},
			showAbout = false,
			sessionProvider,
			joinCommunity,
			editContacts,
			addingNotice,
			login,
			confirmLeave,
			inviteUser,
			muteCommunity,
			unmuteCommunity,
			showAddCouponButton,
			addingCoupon
		} = this.props;

		const sessionUserMembership = getSessionUserMembership(this.props);
		const editable = canAdmin(this.props); // OR global admin
		const cantLeave =
			sessionUserMembership && sessionUserMembership.admin && getAdmins(this.props).length === 1;

		return (
			<section className="CommunitySidePane">
				{addingNotice &&
					sessionProvider &&
					(editable || (sessionUserMembership && noticesAllowAll)) && (
						<PrimaryButton onClick={addingNotice} icon="note_add">
							Create notice
						</PrimaryButton>
					)}

				{showAddCouponButton && (
					<PrimaryButton onClick={addingCoupon} icon="note_add">
						Create Promotion
					</PrimaryButton>
				)}

				{joinCommunity &&
					!sessionUserMembership &&
					userHasBaseDetails(sessionProvider) &&
					uuid !== B2ME_COMM_UUID && (
						<PrimaryButton
							onClick={joinCommunity}
							icon="person_add"
							disabled={sessionProvider.user.exceededMembershipLimit}>
							Join this community
						</PrimaryButton>
					)}
				{!sessionUserMembership && sessionProvider && sessionProvider.user.exceededMembershipLimit && (
					<div className="CommunitySidePane-msg">
						{/* <span>
							You have exceeded the number of memberships for the{' '}
							<b>{sessionProvider.provider.subscriptionLevel} account</b>. Upgrade your account to
							recieve more.
						</span> */}
						<span>
							You have <b>exceeded</b> the number of memberships for your account.
						</span>
					</div>
				)}

				{sessionProvider && sessionUserMembership && (
					<div className="CommunitySidePane-joined">
						<span className="icon icon-playlist_add_check" />
						<div>
							<div className="CommunitySidePane-membershipStatus">
								{editable
									? `You are an administrator of ${name}`
									: sessionUserMembership.status === 'requested'
									? `You have requested membership to ${name}`
									: `You are a member of ${name}`}
							</div>
							<FancyButton onClick={sessionUserMembership.muted ? unmuteCommunity : muteCommunity}>
								{sessionUserMembership.muted ? 'Unmute' : 'Mute'} {name} notifications
							</FancyButton>
							<FancyButton onClick={confirmLeave} disabled={cantLeave}>
								Leave {name}
							</FancyButton>
							{cantLeave && (
								// Admins cannot leave community if they are the only admin
								<div>Cannot leave a community when you are the sole administrator</div>
							)}
						</div>
					</div>
				)}
				{sessionProvider && sessionUserMembership && sessionUserMembership.status === 'approved' && (
					<div className="CommunitySidePane-invite" ref={el => (this.elInvite = el)}>
						<label>
							Invite someone to <em>{name};</em>
						</label>
						<ProviderSearchDropdown
							onSelect={inviteUser}
							scrollIntoViewElement={() => this.elInvite}
						/>
					</div>
				)}
				<SocialList
					contacts={contacts}
					isLoggedIn={!!(sessionProvider && sessionProvider.user)}
					editable={editable}
					onEdit={editContacts}
					onLogin={login}
					name={name}
				/>
				{editable ? (
					<FancyButton className="SocialList-edit" onClick={editContacts}>
						<span className="icon icon-mode_edit" />
						<span>Edit contact details</span>
					</FancyButton>
				) : (
					undefined
				)}
				<CommunityAdminList />
				{showAbout && (
					<div className="CommunitySidePane-bio">
						<h2>About this community</h2>
						<p>{about}</p>
						<Link to={`/about/${uniqueName}`}>Read more</Link>
					</div>
				)}
			</section>
		);
	}
}

const ConnectedCommunitySidePane = connect(
	() => ({}),
	dispatch => ({
		login: () => dispatch(uiActions.uiModal('login')),
		inviteUser: uuid => dispatch(communityActions.inviteUser(uuid)),
		muteCommunity: () => dispatch(communityActions.muteCommunity(true)),
		unmuteCommunity: () => dispatch(communityActions.muteCommunity(false)),
		confirmLeave: () =>
			dispatch(
				confirmActions.open({
					title: `Do you really want to leave this community?`,
					message:
						'You will no longer appear in the members list and you will no longer receive notices.',
					onConfirm: () => dispatch(communityActions.removeMembership()),
					data: 'leaveCommunity'
				})
			)
	})
)(CommunitySidePane);

export default ConnectedCommunitySidePane;



// WEBPACK FOOTER //
// ./src/community/CommunitySidePane.js